import { actionsPreprocessor } from '@/utils/redux';

const actionNames = [
  'FETCH_AGREEMENTS',
  'FETCH_SUCCESS',
  'FETCH_FAILED',

  'CREATE_AGREEMENT',
  'CREATE_AGREEMENT_SUCCESS',
  'CREATE_AGREEMENT_FAILED',

  'TABLE_CHANGE',
];

const { actions, actionTypes } = actionsPreprocessor('agreements', actionNames);

export default actions;
export { actionTypes };
